module.exports = global["p2"] = require("-!/Users/alexeyromanov/Sites/formgame/game/node_modules/phaser/build/custom/p2.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/phaser/build/custom/p2.js
 ** module id = 9
 ** module chunks = 0
 **/